import Navbar from './Navbar.vue';
import AppMain from './AppMain.vue';
import EnTitle from './EnTitle.vue';
import Sidebar from './Sidebar/index.vue';

export {
  Navbar,
  AppMain,
  EnTitle,
  Sidebar
}



// WEBPACK FOOTER //
// ./src/views/layout/components/index.js